module.exports = __webpack_public_path__ + "static/france-bc1ddfd8c13b5ca939eba24e6e1e015d.jpeg";